/**
 * @flow
 * @author: VaraKumar
 */
import styled from 'react-emotion'
import ResponsiveContainer from '../../../core/ResponsiveContainer'

import { Typo30WhiteTwoBNBI } from '../../../../themes/Fonts/Nort'

import { desktop, tablet, mobile } from '../../../../utils/mixins'

export const TestimonialTitleContainer = styled(ResponsiveContainer)`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  font-size: 16px;
  ${desktop} {
    padding-top: 1em;
    padding-bottom: 1.5em;
  }
  ${tablet} {
    padding-top: 1em;
    padding-bottom: 20px;
  }
  ${mobile} {
    padding-top: 0.5em;
    padding-bottom: 1.25em;
  }
`

export const TestimonialHeading = styled(Typo30WhiteTwoBNBI)`
  line-height: 1.23;
  letter-spacing: 0.5px;
  ${mobile} {
    font-size: 1.625em;
    line-height: 2.1875rem;
  }
  ${tablet} {
    font-size: 1.75em;
  }
  ${desktop} {
    font-size: 1.75em;
  }
`
export const PeopleLoveIbCricketImage = styled('img')`
  margin-left: 0.75em;
  margin-right: 0.75em;
`
export const IconContainer = styled('div')`
  user-select: none;
  margin-left: 12px;
  margin-right: 12px;
  display: flex;
  align-items: center;
  @media (min-width: 320px) and (max-width: 334px) {
    margin-left: 5px;
    margin-right: 5px;
  }
`



// WEBPACK FOOTER //
// ./src/components/IbcArcade/TestimonialSection/TestimonialTitle/styledComponents.js